import { render, staticRenderFns } from "./platformList.vue?vue&type=template&id=432291dc&scoped=true&"
import script from "./platformList.vue?vue&type=script&lang=js&"
export * from "./platformList.vue?vue&type=script&lang=js&"
import style0 from "./platformList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./platformList.vue?vue&type=style&index=1&id=432291dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432291dc",
  null
  
)

export default component.exports